import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ViewService } from '../../../../../services/view.service';
import { BaseCustomFieldViewComponent } from '../../../../../base/form';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-report-fields',
  template: `
      <div class="record-texts ng-star-inserted">
        <span class="form-control-plaintext field-list border-bottom form-control-sm pl-2 record-texts long-text ng-star-inserted">
          {{ reportFields.length === 0 ? '--' : translatedFields }}
        </span>
      </div>
  `,
  styles: [`
    .field-list {
      height: auto;
    }

    .no-fields-message {
      text-align: center;
      color: #6c757d;
    }

    .wrap-text {
      white-space: normal;
      word-wrap: break-word;
      text-align: left;
      color: #495057;
    }
  `]
})
export class AssetTypeViewReportFieldsComponent extends BaseCustomFieldViewComponent implements OnInit {
  @Input() reportFields: any[] = [];
  translatedFields: string = '';

  constructor(
    private viewService: ViewService,
    private readonly _translator: TranslateService,

  ) {
    super();
  }

  ngOnInit(): void {
    let loadedField = this.viewService.arRecord.asset_report_fields;
    this.reportFields = loadedField || [];
    this.translatedFields = this.reportFields.map(field => {
      let options = this.viewService.objRecord.used_fields.asset_report_fields.options;

      let matchedOption = options.find(option => option.id === field);
      if (matchedOption) {
        field = matchedOption.text;
      }
      return this._translator.instant(field);
    }).join(', ');
  }
}
